import {
  ActionTypes,
  CLONEDATA,
  CURRENTTAB,
  PACKAGES,
  FORMACTIVED,
  MODELGETLISTUSERSTEP3,
  NEWTAB,
  OFFERFEECODE,
  PRODUCTINFORS,
  PRODUCTVALIDATION,
  USERSTEP3,
  CONTRACTSTATUS,
  CODESTEP2,
  FORMINPUT,
  DATESTEP3,
  FEEAFTERVOUCHER,
  BUSSINESS,
  OLDOBJECTINSUREDINFO,
} from './action'
import {initialState} from './helpers'
import * as Effects from 'redux-saga/effects'
import {
  step2GetContractPackageByCode,
  step3GetObjectInsuredById,
  step3GetObjectInsuredList,
  step4GetContractByID,
  step3GetObjectInsuredByIdentity,
  step2GetContractExtraData,
} from '../apis'
import moment from 'moment'
import {
  calculateDate,
  calculateDateByDateDiff,
  CalculateDateDiff,
  FormateContractPayment,
  formatter,
} from '../../../../utils'
import {validateSpecialChar} from '../../../../utils/Validate'
import {CURRENCYINFOS} from '../../MotoInsurance/redux/actions'

const call: any = Effects.call
const takeLatest = Effects.takeLatest
const put = Effects.put

export const actions = {
  addNewTab: (tab: NEWTAB) => ({type: 'ADDNEWTAB', payload: tab}),
  modifyTab: (tab: CURRENTTAB) => ({type: 'MODIFYTAB', payload: tab}),
  removeTab: (tab: string) => ({type: 'REMOVETAB', payload: tab}),
  activeForm: (active: FORMACTIVED) => ({type: 'ACTIVEFORM', payload: active}),
  addProductInfo: (data: PRODUCTINFORS) => ({type: 'ADDPRODUCTINFORS', payload: data}),
  updatePersonCurrencyInfos: (data: CURRENCYINFOS) => ({
    type: 'UPDATEPERSONCURRENCYINFOS',
    payload: data,
  }),
  getDataOfferFeeByCode: (data: OFFERFEECODE) => ({
    type: 'GETDATAFORMOFFERFEEBYCODE',
    payload: data,
  }),
  saveDataFormOfferFee: (data: any) => ({type: 'SAVEDATAFORMOFFERFEE', payload: data}),
  savePackageExtensions: (data: PACKAGES) => ({
    type: 'SAVEPACKAGEEXTENSIONS',
    payload: data,
  }),
  savePackageInsurances: (data: PACKAGES) => ({
    type: 'SAVEPACKAGEINSURANCES',
    payload: data,
  }),
  getUserStep3ById: (data: USERSTEP3) => ({type: 'GETUSERSTEP3BYID', payload: data}),
  getUserStep3ByIdentity: (data: any) => ({type: 'GETUSERSTEP3BYIDENTITY', payload: data}),
  saveUserStep3ById: (data: any) => ({type: 'SAVEUSERSTEP3BYID', payload: data}),
  saveUserStep3ByIdentity: (data: any) => ({type: 'SAVEUSERSTEP3BYIDENTITY', payload: data}),
  getListUserStep3: (data: MODELGETLISTUSERSTEP3) => ({type: 'GETLISTUSERSTEP3', payload: data}),
  saveListUserStep3: (data: any) => ({type: 'SAVELISTUSERSTEP3', payload: data}),
  getContractStep4ById: (data: any) => ({type: 'GETCONTRACTSTEP4BYID', payload: data}),
  saveContractStep4ById: (data: any) => ({type: 'SAVECONTRACTSTEP4BYID', payload: data}),
  validateFormProduct: (data: PRODUCTVALIDATION) => ({type: 'VALIDATEFORMPRODUCT', payload: data}),
  cloneFormProduct: (data: CLONEDATA) => ({type: 'CLONEDATAFORM', payload: data}),
  cleanFormProduct: (data: CLONEDATA) => ({type: 'CLEANDATAFORM', payload: data}),
  updateContractStatus: (data: CONTRACTSTATUS) => ({type: 'UPDATECONTRACTSTATUS', payload: data}),
  updateCodeStep2: (data: CODESTEP2) => ({type: 'UPDATECODESTEP2', payload: data}),
  updateFormInput: (data: FORMINPUT) => ({type: 'UPDATEFORMINPUT', payload: data}),
  updateDateForm3: (data: DATESTEP3) => ({type: 'UPDATEDATESTEP3', payload: data}),
  updateFeeAfterVoucher: (data: FEEAFTERVOUCHER) => ({
    type: 'UPDATEFEEAFTERVOUCHER',
    payload: data,
  }),
  updateBussiness: (data: BUSSINESS) => ({type: 'UPDATEBUSSINESS', payload: data}),
  updatePackageView: (data: PACKAGES) => ({type: 'UPDATEPACKAGEVIEW', payload: data}),
  updateContractCustomer: (data: CODESTEP2) => ({type: 'UPDATECONTRACTCUSTOMER', payload: data}),
  changeCustomerConfirmDate: (data: FORMINPUT) => ({
    type: 'CHANGECUSTOMERCONFIRMDATE',
    payload: data,
  }),
  updateOriginalPackageType: (data: PACKAGES) => ({
    type: 'UPDATEORIGINALPACKAGETYPE',
    payload: data,
  }),
  updatePackageAdditional: (data: PACKAGES) => ({type: 'UPDATEPACKAGEADDITIONAL', payload: data}),
  updateObjectInsuredInfoFromOld: (data: OLDOBJECTINSUREDINFO) => ({
    type: 'UPDATEOLDOBJECTINSUREDINFO',
    payload: data,
  }),
}

export const personInsuReducer = (state = initialState, action: ActionTypes | any) => {
  switch (action.type) {
    case 'ADDNEWTAB':
      const newTabState = JSON.parse(JSON.stringify(state))
      if (state.length === 1 && state[0].tabName == undefined) {
        newTabState[0].tabName = action.payload.tab
        newTabState[0].sellingContractId = action.payload.tab
        newTabState[0].customerCode = action.payload.customerCode
        newTabState[0].customerVersion = action.payload.customerVersion
        newTabState[0].groupDomainCode = action.payload.groupDomainCode
        newTabState[0].contractType = action.payload.contractType
        newTabState[0].contractKind = action.payload.contractKind
        newTabState[0].originalContract = action.payload.originalContract
        newTabState[0].customerName = action.payload.customerName
        newTabState[0].addressName = action.payload.addressName
        newTabState[0].customerBirthDay = action.payload.customerBirthDay
        newTabState[0].gender = action.payload.gender
        newTabState[0].phone = action.payload.phone
        newTabState[0].mobile = action.payload.mobile
        newTabState[0].email = action.payload.email
        newTabState[0].customerType = action.payload.customerType
        newTabState[0].customerSegment = action.payload.customerSegment
        newTabState[0].identificationNumber = action.payload.identificationNumber
        newTabState[0].taxNumber = action.payload.taxNumber
        newTabState[0].divisionId = action.payload.divisionId
        newTabState[0].form.activeForm = 1
      } else {
        const obj = {
          tabName: action.payload.tab,
          sellingContractId: action.payload.tab,
          customerCode: action.payload.customerCode,
          customerVersion: action.payload.customerVersion,
          groupDomainCode: action.payload.groupDomainCode,
          contractType: action.payload.contractType,
          contractKind: action.payload.contractKind,
          originalContract: action.payload.originalContract,
          customerName: action.payload.customerName,
          addressName: action.payload.addressName,
          customerBirthDay: action.payload.customerBirthDay,
          gender: action.payload.gender,
          phone: action.payload.phone,
          mobile: action.payload.mobile,
          email: action.payload.email,
          customerType: action.payload.customerType,
          customerSegment: action.payload.customerSegment,
          identificationNumber: action.payload.identificationNumber,
          taxNumber: action.payload.taxNumber,
          divisionId: action.payload.divisionId,
          packageExtension: undefined,
          packageInsurance: undefined,
          form: {
            activeForm: 1,
            formStatus: null,
            packageCodeView: null,
            packageConditional: null,
            formData: {
              formPersonInsurancePlan: {
                businessProgramCode: null,
                productCode: null,
                exploitingType: null,
                exploitingCode: null,
                typeOfIntroduction: null,
                introductionCode: null,
                curencyMoney: null,
                curencyFee: null,
                exchangeRate: '1',
                exchangeRateNote: null,
                business: null,
                businessName: null,
                paymentTimeType: '0',
                calculationType: '0',
                nationality: null,
                currencyFeeChange: null,
                validateForm: null,
                tpa: null,
                tpaType: null,
                tpaFee: null,
                adjacentContractNumberLoss: null,
                adjacentContractNumber: null,
                amountPeople: null,
                commission: '0',
                adminFee: '0',
              },
              formPersonOfferFee: {
                id: null,
                packageCode: null,
                name: null,
                code: null,
                salary: '0',
                startDate: moment().format('YYYY/MM/DD'),
                expireDate: calculateDate(moment().format('YYYY/MM/DD'), false),
                amountPeople: 1,
                _sellingContractPeoplePackageBenefitDtos: null,
                _sellingContractPeoplePackageExtensionDtos: null,
                _sellingContractPeoplePackageWaitingDtos: [],
                _sellingContractPeoplePackageNoteDtos: [],
                validateForm: null,
                packageInsuredType: null,
                approveRate: null,
                coverage: null,
                packagesType: null,
                contractPackageType: null,
                validateCalculateFee: false,
                listObjectSelected: null,
                fieldInput: [],
                codeOption: null,
                oldPackageCode: null,
              },
              formPersonListUser: {
                id: null,
                customerName: null,
                customerCode: null,
                customerVersion: null,
                code: null,
                identificationNumber: null,
                customerBirthDay: null,
                addtionalBenefit: null,
                objectInsuredType: null,
                gender: null,
                packageCode: null,
                coverage: 'Viet Nam',
                mobile: null,
                email: null,
                startDate: moment().format('YYYY/MM/DD HH:mm'),
                expireDate: calculateDate(moment().format('YYYY/MM/DD HH:mm'), true),
                salary: null,
                oldContractCode: null,
                oldContractExitDate: null,
                relationsShip: null,
                addressName: null,
                partner: null,
                position: null,
                employeeCode: null,
                creditContractNumber: null,
                payeeName: null,
                payeeNameIdentificationNumber: null,
                payeesRelationsShip: null,
                note: null,
                validateForm: null,
                listUser: null,
                totalRowList: null,
                packageChosed: null,
                listObjectSelected: null,
                lossRatioRate: null,
                fieldInput: [],
                nationality: null,
                cmtReference: null,
                loanAmount: null,
              },
              formPersonContract: {
                agency: null,
                contractType: null,
                contractNumber: null,
                originalCode: null,
                created: null,
                purchaseDate: null,
                startDate: null,
                expireDate: null,
                manager: null,
                totalPerson: null,
                sumFee: null,
                partyARepresentative: null,
                partyAPosition: null,
                partyBRepresentative: null,
                partyBPosition: null,
                partyBPhone: null,
                partyAPhone: null,
                partyAPowerOfAttorney: null,
                partyBPowerOfAttorney: null,
                partyBFax: null,
                proxy: null,
                bankCode: null,
                bankNumber: null,
                _sellingContractPaymentScheduleDtos: null,
                _sellingContractExtraDataDtos: null,
                _listContractPackages: null,
                lossRatio: null,
                validateForm: null,
                exploName: null,
                exploManager: null,
                exploitingType: null,
                tsIncharge: null,
                pmIncharge: null,
                paymentTimeType: null,
                commission: '0',
                adminFee: '0',
                vatAdminFee: null,
                endorStartDate: null,
                endorExpireDate: null,
                endorNote: null,
                userReceiveMail: null,
                customerConfirmDate: null,
                dateDiff: null,
                numberOfPaymentSchedule: null,
              },
            },
          },
        }
        newTabState.push(obj)
      }
      return newTabState
    case 'REMOVETAB':
      const tabState = JSON.parse(JSON.stringify(state))
      const tabRemoved = tabState.filter((o: any) => o.tabName !== action.payload)
      return tabRemoved
    case 'MODIFYTAB':
      const modifyTabState = JSON.parse(JSON.stringify(state))
      const currentModifyTab = modifyTabState.find(
        (o: any) => o.tabName == action.payload.currentTab
      )
      if (currentModifyTab) {
        currentModifyTab.sellingContractId = action.payload.newTabName
        currentModifyTab.customerCode = action.payload.customerCode
        currentModifyTab.customerVersion = action.payload.customerVersion
        currentModifyTab.groupDomainCode = action.payload.groupDomainCode
        if (action.payload?.contractType)
          currentModifyTab.contractType = action.payload.contractType
        if (action.payload?.contractKind)
          currentModifyTab.contractKind = action.payload.contractKind
      }
      return modifyTabState
    case 'ACTIVEFORM':
      const activeFormState = JSON.parse(JSON.stringify(state))
      let currentTab = activeFormState.find((o: any) => o.tabName == action.payload.tab)
      if (currentTab) {
        currentTab.form.activeForm = action.payload.form
      }
      return activeFormState
    case 'ADDPRODUCTINFORS':
      const {key, value, tab, form} = action.payload
      const addProductState = JSON.parse(JSON.stringify(state))
      let tabCurrent = addProductState.find((o: any) => o.tabName == tab)
      if (tabCurrent) {
        tabCurrent.form.formData[form][key] = value
        if (key == 'exchangeRate') {
          if (value && value !== '' && typeof value == 'string') {
            let convert = value.replaceAll(',', '')
            if (!isNaN(parseInt(convert))) {
              let test = validateSpecialChar(value)
              if (!test) {
                tabCurrent.form.formData[form][key] = formatter(parseInt(convert))
              } else tabCurrent.form.formData[form][key] = formatter(parseInt(value))
            } else tabCurrent.form.formData[form][key] = null
          } else if (typeof value == 'number') {
            tabCurrent.form.formData[form][key] = formatter(value)
          }
        }
        if (tabCurrent.contractType != 2) {
          if (form == 'formPersonOfferFee') {
            if (key == 'startDate') {
              let dataCalculated = calculateDate(value, false)
              tabCurrent.form.formData.formPersonOfferFee.expireDate = dataCalculated
            }
          }
          if (form == 'formPersonListUser') {
            if (key == 'startDate') {
              let dataCalculated = calculateDate(value, true)
              tabCurrent.form.formData.formPersonListUser.expireDate = dataCalculated
            }
          }
          if (form == 'formPersonContract') {
            if (key === 'startDate') {
              let dateDiff = tabCurrent.form.formData.formPersonContract.dateDiff
              if (dateDiff) {
                let dataCalculated = calculateDateByDateDiff(value, false, dateDiff, 'day')
                tabCurrent.form.formData.formPersonContract.expireDate = dataCalculated
              }
            }
          }
        }
      }
      return addProductState
    case 'UPDATEPERSONCURRENCYINFOS':
      const personCurrencyState = JSON.parse(JSON.stringify(state))
      const personCurrencyTab = personCurrencyState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (personCurrencyTab) {
        personCurrencyTab.form.formData.formPersonInsurancePlan.curencyMoney =
          action.payload.curencyMoney
        personCurrencyTab.form.formData.formPersonInsurancePlan.curencyFee =
          action.payload.curencyFee
      }
      return personCurrencyState
    case 'GETDATAFORMOFFERFEEBYCODE':
      return state
    case 'SAVEDATAFORMOFFERFEE':
      const offerFeeState = JSON.parse(JSON.stringify(state))
      const offerFeeTab = offerFeeState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (offerFeeTab) {
        offerFeeTab.form.formData.formPersonOfferFee.oldPackageCode = action.payload?.oldPackageCode
          ? action.payload?.oldPackageCode
          : null
        offerFeeTab.form.formData.formPersonOfferFee.id = action.payload.id
        offerFeeTab.form.formData.formPersonOfferFee.packageCode = action.payload.packageCode
        offerFeeTab.form.formData.formPersonOfferFee.originalPackageCode =
          action.payload.packageCode
        offerFeeTab.form.formData.formPersonOfferFee.name = action.payload.name
        offerFeeTab.form.formData.formPersonOfferFee.code = action.payload.code
        offerFeeTab.form.formData.formPersonOfferFee.idPackages = action.payload.id
        offerFeeTab.form.formData.formPersonOfferFee.packageInsuredType =
          action.payload?.packageInsuredType
        offerFeeTab.form.formData.formPersonOfferFee.coverage = action.payload.coverage
        offerFeeTab.form.formData.formPersonOfferFee.lossRatio = action.payload.lossRatio
        offerFeeTab.form.formData.formPersonOfferFee.codeOption = action.payload.codeOption
        offerFeeTab.form.formData.formPersonOfferFee.offerRate = action.payload.offerRate
        offerFeeTab.form.formData.formPersonOfferFee.contractPackageType =
          action.payload.contractPackageType
        offerFeeTab.form.formData.formPersonOfferFee.startDate = moment(
          action.payload.startDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        offerFeeTab.form.formData.formPersonOfferFee.expireDate = moment(
          action.payload.expireDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        offerFeeTab.form.formData.formPersonOfferFee.salary = formatter(action.payload.salary)
        offerFeeTab.form.formData.formPersonOfferFee.amountPeople = action.payload.amountPeople
        offerFeeTab.form.formData.formPersonOfferFee.originFee = action.payload.originFee
        offerFeeTab.form.formData.formPersonOfferFee.discountFee = action.payload.discountFee
        offerFeeTab.form.formData.formPersonOfferFee.channelFee = action.payload.channelFee
        offerFeeTab.form.formData.formPersonOfferFee._sellingContractPeoplePackageBenefitDtos =
          action.payload._sellingContractPeoplePackageBenefitDtos
        offerFeeTab.form.formData.formPersonOfferFee._sellingContractPeoplePackageExtensionDtos =
          action.payload._sellingContractPeoplePackageExtensionDtos
        offerFeeTab.form.formData.formPersonOfferFee._sellingContractPeoplePackageWaitingDtos =
          action.payload._sellingContractPeoplePackageWaitingDtos
        offerFeeTab.form.formData.formPersonOfferFee._sellingContractPeoplePackageNoteDtos =
          action.payload._sellingContractPeoplePackageNoteDtos

        offerFeeTab.form.formData.formPersonOfferFee._sellingContractPeoplePackageBenefitDtos.map(
          (o: any) => {
            o.checkboxF = true
            if (o.startDate != '01/01/0001')
              o.startDate = moment(o.startDate, 'DD/MM/YYYY').toDate()
            if (o.expireDate != '01/01/0001')
              o.expireDate = moment(o.expireDate, 'DD/MM/YYYY').toDate()
          }
        )
        offerFeeTab.form.formData.formPersonOfferFee._sellingContractPeoplePackageExtensionDtos.map(
          (o: any) => (o.checkboxExt = true)
        )
      }
      return offerFeeState
    case 'SAVEPACKAGEEXTENSIONS':
      const extensionState = JSON.parse(JSON.stringify(state))
      const extensionTab = extensionState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (extensionTab) {
        extensionTab.packageExtension = action.payload.data
      }
      return extensionState
    case 'SAVEPACKAGEINSURANCES':
      const packageInsuranceState = JSON.parse(JSON.stringify(state))
      const packageInsuranceTab = packageInsuranceState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (packageInsuranceTab) {
        packageInsuranceTab.packageInsurance = action.payload.data
        packageInsuranceTab.form.formData.formPersonOfferFee.packageCode = null
      }
      return packageInsuranceState
    case 'GETUSERSTEP3BYID':
      return state
    case 'GETUSERSTEP3BYIDENTITY':
      return state
    case 'SAVEUSERSTEP3BYID':
      const saveUserState = JSON.parse(JSON.stringify(state))
      const saveUserTab = saveUserState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId.toString()
      )
      if (saveUserTab) {
        saveUserTab.form.formData.formPersonListUser.certNumber = action.payload.certNumber
        saveUserTab.form.formData.formPersonListUser.certType = action.payload.certType
        saveUserTab.form.formData.formPersonListUser.discountRate = action.payload?.discountRate
        saveUserTab.form.formData.formPersonListUser.discountRateApprove =
          action.payload?.discountRateApprove
        saveUserTab.form.formData.formPersonListUser.id = action.payload.id
        saveUserTab.form.formData.formPersonListUser.customerName =
          action.payload.objectInsuredInfo.name
        saveUserTab.form.formData.formPersonListUser.customerCode = action.payload.customerCode
        saveUserTab.form.formData.formPersonListUser.customerVersion =
          action.payload.customerVersion
        saveUserTab.form.formData.formPersonListUser.code = action.payload.code
        saveUserTab.form.formData.formPersonListUser.identificationNumber =
          action.payload.objectInsuredInfo.identificationNumber
        saveUserTab.form.formData.formPersonListUser.customerBirthDay = action.payload
          .objectInsuredInfo.birthday
          ? moment(action.payload.objectInsuredInfo.birthday, 'DD/MM/YYYY').format('YYYY/MM/DD')
          : null
        saveUserTab.form.formData.formPersonListUser.gender =
          action.payload.objectInsuredInfo.gender
        saveUserTab.form.formData.formPersonListUser.addtionalBenefit =
          action.payload.addtionalBenefit?.split(',')
        saveUserTab.form.formData.formPersonListUser.objectInsuredType =
          action.payload.objectInsuredType == 0 ? 1 : action.payload.objectInsuredType
        saveUserTab.form.formData.formPersonListUser.packageCode =
          action.payload.packageCode || null
        // saveUserTab.form.formData.formPersonListUser.coverage = action.payload.coverage || null
        saveUserTab.form.formData.formPersonListUser.mobile =
          action.payload.objectInsuredInfo.mobile
        saveUserTab.form.formData.formPersonListUser.email = action.payload.objectInsuredInfo.email
        saveUserTab.form.formData.formPersonListUser.startDate = action.payload.startDate
          ? moment(action.payload.startDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
          : null
        saveUserTab.form.formData.formPersonListUser.expireDate = action.payload.expireDate
          ? moment(action.payload.expireDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
          : null
        saveUserTab.form.formData.formPersonListUser.endorStartDate = action.payload?.endorStartDate
          ? moment(action.payload.endorStartDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
          : null
        saveUserTab.form.formData.formPersonListUser.endorExpireDate = action.payload
          ?.endorExpireDate
          ? moment(action.payload.endorExpireDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
          : null
        saveUserTab.form.formData.formPersonListUser.salary = action.payload
          .objectInsuredPeopleDtos[0]
          ? formatter(action.payload.objectInsuredPeopleDtos[0].salary)
          : null
        saveUserTab.form.formData.formPersonListUser.oldContractCode =
          action.payload.oldContractCode || null
        saveUserTab.form.formData.formPersonListUser.oldContractExitDate =
          action.payload.oldContractExitDate || null
        saveUserTab.form.formData.formPersonListUser.relationsShip = action.payload
          .objectInsuredPeopleDtos[0]
          ? action.payload.objectInsuredPeopleDtos[0].relationsShip
          : null
        saveUserTab.form.formData.formPersonListUser.addressName =
          action.payload.objectInsuredInfo.addressName
        saveUserTab.form.formData.formPersonListUser.sumFee = action.payload.sumFee
        saveUserTab.form.formData.formPersonListUser.sumTax = action.payload.sumTax
        saveUserTab.form.formData.formPersonListUser.partner =
          action.payload.objectInsuredInfo.partner || null
        saveUserTab.form.formData.formPersonListUser.position =
          action.payload.objectInsuredInfo.position || null
        saveUserTab.form.formData.formPersonListUser.employeeCode = action.payload.employeeCode
        saveUserTab.form.formData.formPersonListUser.creditContractNumber =
          action.payload.creditContractNumber
        saveUserTab.form.formData.formPersonListUser.payeeName = action.payload.payeeName || null
        saveUserTab.form.formData.formPersonListUser.payeeNameIdentificationNumber =
          action.payload.payeeNameIdentificationNumber || null
        saveUserTab.form.formData.formPersonListUser.payeesRelationsShip =
          action.payload.payeesRelationsShip || null
        saveUserTab.form.formData.formPersonListUser.note =
          action.payload.objectInsuredInfo.note || null
        saveUserTab.form.formData.formPersonListUser.cmtReference =
          action.payload.cmtReference || null
        saveUserTab.form.formData.formPersonListUser.from =
          action.payload.objectInsuredPeopleDtos[0].from
        saveUserTab.form.formData.formPersonListUser.to =
          action.payload.objectInsuredPeopleDtos[0].to
        saveUserTab.form.formData.formPersonListUser.toOther =
          action.payload.objectInsuredPeopleDtos[0].toOther
        saveUserTab.form.formData.formPersonListUser.coverage = action.payload.coverage
        saveUserTab.form.formData.formPersonListUser.nationality = action.payload.nationality
        saveUserTab.form.formData.formPersonListUser.loanAmount = action.payload
          .objectInsuredPeopleDtos[0].loanAmount
          ? formatter(action.payload.objectInsuredPeopleDtos[0].loanAmount)
          : null
      }
      return saveUserState
    case 'SAVEUSERSTEP3BYIDENTITY':
      const bindUserState = JSON.parse(JSON.stringify(state))
      const bindUserTab = bindUserState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId.toString()
      )
      if (
        bindUserTab &&
        action.payload.objectInsuredInfo.customerCode !==
          bindUserTab.form.formData.formPersonListUser.customerCode
      ) {
        bindUserTab.form.formData.formPersonListUser.customerName =
          action.payload.objectInsuredInfo.name
        bindUserTab.form.formData.formPersonListUser.customerCode = action.payload.customerCode
        bindUserTab.form.formData.formPersonListUser.customerVersion =
          action.payload.customerVersion
        bindUserTab.form.formData.formPersonListUser.customerBirthDay = action.payload
          .objectInsuredInfo.birthday
          ? moment(action.payload.objectInsuredInfo.birthday, 'DD/MM/YYYY').format('YYYY/MM/DD')
          : null
        bindUserTab.form.formData.formPersonListUser.gender =
          action.payload.objectInsuredInfo.gender
        bindUserTab.form.formData.formPersonListUser.mobile =
          action.payload.objectInsuredInfo.mobile
        bindUserTab.form.formData.formPersonListUser.email = action.payload.objectInsuredInfo.email
        bindUserTab.form.formData.formPersonListUser.oldContractCode =
          action.payload.oldContractCode || null
        bindUserTab.form.formData.formPersonListUser.oldContractExitDate =
          action.payload.oldContractExitDate || null
        bindUserTab.form.formData.formPersonListUser.addressName =
          action.payload.objectInsuredInfo.addressName
      }
      return bindUserState
    case 'GETLISTUSERSTEP3':
      return state
    case 'SAVELISTUSERSTEP3':
      const stateListUser = JSON.parse(JSON.stringify(state))
      const listUsersTab = stateListUser.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (listUsersTab) {
        let arr: any = []
        if (
          action.payload.data &&
          action.payload.data.items &&
          action.payload.data.items.length > 0
        ) {
          action.payload.data.items.map((o: any) => {
            let obj = {
              id: o.id,
              name: o.objectInsuredInfo?.name,
              fee: formatter(o.sumFee),
              tax: o.sumTax ? formatter(o.sumTax) : 0,
              sumFee: formatter(o.sumFee + o.sumTax),
              oldfee: o.oldFee ? formatter(o.oldFee) : 0,
              diffee: formatter(o.sumFee - (o.oldFee ? o.oldFee : o.sumFee)),
              discountRate: o.discountRate,
              discountRateApprove: o.discountRateApprove,
              birthday: o.objectInsuredInfo?.birthday ? o.objectInsuredInfo.birthday : '',
              identity: o.objectInsuredInfo?.identificationNumber,
              phone: o.objectInsuredInfo?.phone,
              gender: o.objectInsuredInfo?.gender,
              email: o.objectInsuredInfo?.email,
              addressName: o.objectInsuredInfo?.addressName,
              certificate: o.certNumber ? o.certNumber : '',
              objectInsuredTypeName: o.objectInsuredTypeName,
              status: o.status ? o.status : '',
              packageCode: o.packageCode,
              coverage: o.coverage,
              from: o.objectInsuredPeopleDtos[0].from,
              to: o.objectInsuredPeopleDtos[0].to,
              toOther: o.objectInsuredPeopleDtos[0].from,
              relationsShip: o.objectInsuredPeopleDtos[0].relationsShip,
              nationality: o.objectInsuredInfo.nationality,
              startDate: o.startDate.substring(0, 10),
              expireDate: o.expireDate.substring(0, 10),
              created: o.created,
            }
            arr.push(obj)
          })
        }
        listUsersTab.form.formData.formPersonListUser.totalRowList = action.payload.data.totalItems
        listUsersTab.form.formData.formPersonListUser.listUser = arr
      }
      return stateListUser
    case 'GETCONTRACTSTEP4BYID':
      return state
    case 'SAVECONTRACTSTEP4BYID':
      const saveContractState = JSON.parse(JSON.stringify(state))
      const saveContractTab = saveContractState.find(
        (o: any) => o.sellingContractId == action.payload.id
      )
      if (saveContractTab) {
        saveContractTab.form.formData.formPersonContract.agency = action.payload?.agency
          ? action.payload?.agency
          : null
        saveContractTab.form.formData.formPersonContract.contractNumber =
          action.payload.contractNumber
        saveContractTab.form.formData.formPersonContract.originalCode = action.payload.originalCode
        saveContractTab.form.formData.formPersonContract.created = moment(
          action.payload.createdDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        saveContractTab.form.formData.formPersonContract.contractType = action.payload.contractType
        saveContractTab.form.formData.formPersonContract.startDate = moment(
          action.payload.startDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        saveContractTab.form.formData.formPersonContract.purchaseDate = action.payload.purchaseDate
          ? moment(action.payload.purchaseDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
          : null
        saveContractTab.form.formData.formPersonContract.manager = action.payload.manager
        saveContractTab.form.formData.formPersonContract.expireDate = moment(
          action.payload.expireDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        saveContractTab.form.formData.formPersonContract.dateDiff = CalculateDateDiff(
          action.payload.startDate,
          action.payload.expireDate
        )
        saveContractTab.form.formData.formPersonContract.totalPerson = action.payload.amountPeople
        saveContractTab.form.formData.formPersonContract.adjacentContractNumber =
          action.payload.adjacentContractNumber
        saveContractTab.form.formData.formPersonContract.adjacentContractNumberLoss =
          action.payload.adjacentContractNumberLoss
        saveContractTab.form.formData.formPersonContract.partyARepresentative =
          action.payload.partyARepresentative
        saveContractTab.form.formData.formPersonContract.partyBRepresentative =
          action.payload.partyBRepresentative
        saveContractTab.form.formData.formPersonContract.partyAPowerOfAttorney =
          action.payload.partyAPowerOfAttorney
        saveContractTab.form.formData.formPersonContract.partyBPowerOfAttorney =
          action.payload.partyBPowerOfAttorney
        saveContractTab.form.formData.formPersonContract.partyAPosition =
          action.payload.partyAPosition
        saveContractTab.form.formData.formPersonContract.partyBFax = action.payload.partyBFax
        saveContractTab.form.formData.formPersonContract.partyBPhone = action.payload.partyBPhone
        saveContractTab.form.formData.formPersonContract.partyAPhone = action.payload.partyAPhone
        saveContractTab.form.formData.formPersonContract.partyBPosition =
          action.payload.partyBPosition
        saveContractTab.form.formData.formPersonContract.bankCode = action.payload.bankCode
        saveContractTab.form.formData.formPersonContract.bankNumber = action.payload.bankNumber
        saveContractTab.form.formData.formPersonContract.taxType = action.payload.taxType
        saveContractTab.form.formData.formPersonContract._sellingContractPaymentScheduleDtos =
          FormateContractPayment(action.payload._sellingContractPaymentScheduleDtos)
        saveContractTab.form.formData.formPersonContract._sellingContractExtraDataDtos =
          action.payload._sellingContractExtraDataDtos
        saveContractTab.form.formData.formPersonContract._listContractPackages =
          action.payload._listContractPackages
        saveContractTab.form.formData.formPersonContract.sumFee = formatter(action.payload.sumFee)
        saveContractTab.form.formData.formPersonContract.sumTax = formatter(action.payload.sumTax)
        if (action.payload.giftCode)
          saveContractTab.form.formData.formPersonContract.giftCode = action.payload.giftCode
        saveContractTab.form.formData.formPersonContract.discount = action.payload.discount
          ? formatter(action.payload.discount)
          : 0
        saveContractTab.form.formData.formPersonContract.exploName = action.payload.exploName
        saveContractTab.form.formData.formPersonContract.exploManager = action.payload.exploManager
        saveContractTab.form.formData.formPersonContract.tsIncharge = action.payload?.tsIncharge
        saveContractTab.form.formData.formPersonContract.pmIncharge = action.payload?.pmIncharge
        saveContractTab.form.formData.formPersonContract.dateMoF = action.payload?.dateMoF
          ? moment(action.payload?.dateMoF, 'DD/MM/YYYY').format('YYYY/MM/DD')
          : null
        saveContractTab.form.formData.formPersonContract.paymentTimeType =
          action.payload?.paymentTimeType
        saveContractTab.form.formData.formPersonContract.commission = action.payload?.commission
        saveContractTab.form.formData.formPersonContract.adminFee = action.payload?.adminFee
        saveContractTab.form.formData.formPersonContract.customerConfirmDate = action.payload
          ?.customerConfirmDate
          ? moment(action.payload?.customerConfirmDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
          : null
        saveContractTab.form.formData.formPersonContract.vatAdminFee =
          action.payload?.taxTypeAdminFee
        saveContractTab.form.formData.formPersonContract.exploitingType =
          action.payload.exploitingType
        saveContractTab.form.formData.formPersonContract.userReceiveMail =
          action.payload?.userReceiveMail
        saveContractTab.form.formData.formPersonContract.numberOfPaymentSchedule =
          action.payload?.numberOfPaymentSchedule
        if (action.payload?.endorExpireDate) {
          saveContractTab.form.formData.formPersonContract.endorExpireDate = moment(
            action.payload?.endorExpireDate,
            'YYYY-MM-DD'
          ).format('YYYY/MM/DD')
        } else
          saveContractTab.form.formData.formPersonContract.endorExpireDate =
            saveContractTab.form.formData.formPersonContract.expireDate
        if (action.payload?.endorStartDate) {
          saveContractTab.form.formData.formPersonContract.endorStartDate = moment(
            action.payload?.endorStartDate,
            'YYYY-MM-DD'
          ).format('YYYY/MM/DD')
        }

        step2GetContractExtraData(action.payload.id)
          .then((res: any) => {
            if (res && !res.isError) {
              let check = res.data.find(
                (o: any) =>
                  o.name == 'NGAY_KHACH_HANG_DONG_Y' && o.sellingContractId == action.payload.id
              )
              let obj = {
                sellingContractId: action.payload.id,
                data: check ? check : null,
              }
              action.asyncDispatch({type: 'SAVECUSTOMERCONFIRMDATE', payload: obj})
            }
          })
          .catch((error) => {
            return
          })
      }
      return saveContractState
    case 'SAVECUSTOMERCONFIRMDATE':
      const saveCustomerConfirmDateState = JSON.parse(JSON.stringify(state))
      const saveCustomerConfirmDateTab = saveCustomerConfirmDateState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (saveCustomerConfirmDateTab) {
        saveCustomerConfirmDateTab.form.formData.formPersonContract.customerConfirmDate =
          action.payload.data
      }
      return saveCustomerConfirmDateState
    case 'CHANGECUSTOMERCONFIRMDATE':
      const changeCustomerConfirmDateState = JSON.parse(JSON.stringify(state))
      const changeCustomerConfirmDateTab = changeCustomerConfirmDateState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (changeCustomerConfirmDateTab) {
        if (changeCustomerConfirmDateTab.form.formData.formPersonContract.customerConfirmDate) {
          changeCustomerConfirmDateTab.form.formData.formPersonContract.customerConfirmDate.describe =
            action.payload.data
        } else {
          changeCustomerConfirmDateTab.form.formData.formPersonContract.customerConfirmDate = {
            id: null,
            name: 'NGAY_KHACH_HANG_DONG_Y',
            text: 'Ngày khách hàng đồng ý chào phí',
            sellingContractId: action.payload.tab,
            describe: action.payload.data,
            extraField3: '',
          }
        }
      }
      return changeCustomerConfirmDateState
    case 'VALIDATEFORMPRODUCT':
      const validateState = JSON.parse(JSON.stringify(state))
      const validateTab = validateState.find((o: any) => o.tabName == action.payload.tab)
      if (validateTab) {
        validateTab.form.formData[action.payload.form].validateForm = action.payload.isError
      }
      return validateState
    case 'CLONEDATAFORM':
      const cloneState = JSON.parse(JSON.stringify(state))
      const cloneTab = cloneState.find((o: any) => o.tabName == action.payload.tab)
      if (cloneTab) {
        cloneTab.form.formData[action.payload.form].id = null
        if (action.payload.form == 'formPersonOfferFee') {
          cloneTab.form.formData[action.payload.form].name = null
          cloneTab.form.formData.formPersonListUser.listUser = []
        } else if (action.payload.form == 'formPersonListUser') {
          cloneTab.form.formData[action.payload.form].customerName = null
          cloneTab.form.formData[action.payload.form].identificationNumber = null
          cloneTab.form.formData[action.payload.form].customerBirthDay = null
        }
      }
      return cloneState
    case 'CLEANDATAFORM':
      const cleanState = JSON.parse(JSON.stringify(state))
      const cleanTab = cleanState.find((o: any) => o.tabName == action.payload.tab)
      if (cleanTab) {
        for (const o in cleanTab.form.formData[action.payload.form]) {
          if (action.payload.form == 'formPersonOfferFee') {
            if (
              // o !== 'packageCode' &&
              // o !== '_sellingContractPeoplePackageBenefitDtos' &&
              // o !== '_sellingContractPeoplePackageExtensionDtos' &&
              o !== 'startDate' &&
              o !== 'expireDate' &&
              o !== 'fieldInput' &&
              o !== 'packageInsuredType' &&
              o !== 'amountPeople' &&
              o !== 'salary'
            ) {
              cleanTab.form.formData[action.payload.form][o] = null
            }
            if (cleanTab.packageExtension?.length > 0) {
              if (o === 'startDate') {
                cleanTab.form.formData[action.payload.form][o] = moment(
                  cleanTab.packageExtension[0]?.startDate,
                  'DD/MM/YYYY'
                ).format('YYYY/MM/DD')
                cleanTab.form.formData.formPersonOfferFee.expireDate = moment(
                  cleanTab.packageExtension[0]?.expireDate,
                  'DD/MM/YYYY'
                ).format('YYYY/MM/DD')
              }
            } else if (o == 'startDate') {
              let date = moment().format('YYYY/MM/DD')
              cleanTab.form.formData[action.payload.form][o] = date
              let dataCalculated = calculateDate(date, false)
              cleanTab.form.formData.formPersonOfferFee.expireDate = dataCalculated
            } else if (o === 'salary') {
              cleanTab.form.formData[action.payload.form][o] = '0'
            }
            cleanTab.form.formData.formPersonListUser.listUser = []
          } else if (action.payload.form == 'formPersonListUser') {
            if (
              o !== 'startDate' &&
              o !== 'expireDate' &&
              o !== 'objectInsuredType' &&
              o !== 'listUser' &&
              o !== 'totalRowList' &&
              o !== 'packageChosed' &&
              o !== 'listObjectSelected' &&
              o != 'fieldInput'
            ) {
              cleanTab.form.formData[action.payload.form][o] = null
            } else if (o == 'startDate') {
              let date = moment().format('YYYY/MM/DD HH:mm')
              cleanTab.form.formData[action.payload.form][o] = date
              let dataCalculated = calculateDate(date, true)
              cleanTab.form.formData[action.payload.form].expireDate = dataCalculated
            } else if (o == 'objectInsuredType') {
              cleanTab.form.formData[action.payload.form][o] = '1'
            }
          }
        }
      }
      return cleanState
    case 'UPDATECONTRACTSTATUS':
      const contractStatusState = JSON.parse(JSON.stringify(state))
      let contractStatusTab = contractStatusState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (contractStatusTab) {
        contractStatusTab.form.formStatus = action.payload.status
      }
      return contractStatusState
    case 'UPDATECODESTEP2':
      const updateCodeStep2State = JSON.parse(JSON.stringify(state))
      let updateCodeStep2Tab = updateCodeStep2State.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (updateCodeStep2Tab) {
        updateCodeStep2Tab.form.formData.formPersonOfferFee.id = action.payload.id
        updateCodeStep2Tab.form.formData.formPersonOfferFee.code = action.payload.code
      }
      return updateCodeStep2State
    case 'UPDATEFORMINPUT':
      const updateFormInputState = JSON.parse(JSON.stringify(state))
      let updateFormInputTab = updateFormInputState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (updateFormInputTab) {
        let inputForm2 = action.payload.data?.filter((o: any) => o.contractSellingStep == 2)
        let inputForm3 = action.payload.data?.filter((o: any) => o.contractSellingStep == 3)

        if (inputForm2) {
          updateFormInputTab.form.formData.formPersonOfferFee.fieldInput = [
            ...updateFormInputTab.form.formData.formPersonOfferFee.fieldInput,
            ...inputForm2,
          ]
        }
        if (inputForm3) {
          inputForm3.forEach((elem: any) => {
            if (elem.fieldName === 'InsuredPersonEmail') {
              elem.fieldName = 'Email'
            }
            if (elem.fieldName === 'InsuredPersonPhone') {
              elem.fieldName = 'Mobile'
            }
            if (elem.fieldName === 'InsuredPersonAddress') {
              elem.fieldName = 'Address'
            }
            if (elem.fieldName === 'InsuredPersonIdentityCard') {
              elem.fieldName = 'IdentificationNumber'
            }
          })
          updateFormInputTab.form.formData.formPersonListUser.fieldInput = [
            ...updateFormInputTab.form.formData.formPersonListUser.fieldInput,
            ...inputForm3,
          ]
        }
      }
      return updateFormInputState
    case 'UPDATEDATESTEP3':
      const updateDateStep3State = JSON.parse(JSON.stringify(state))
      let updateDateStep3Tab = updateDateStep3State.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (updateDateStep3Tab) {
        updateDateStep3Tab.form.formData.formPersonListUser.startDate = moment(
          action.payload.startDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD HH:mm')
        updateDateStep3Tab.form.formData.formPersonListUser.expireDate = moment(
          action.payload.expireDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD HH:mm')
      }
      return updateDateStep3State
    case 'UPDATEFEEAFTERVOUCHER':
      const updateFeeAfterVoucherState = JSON.parse(JSON.stringify(state))
      let updateFeeAfterVoucherTab = updateFeeAfterVoucherState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (updateFeeAfterVoucherTab) {
        updateFeeAfterVoucherTab.form.formData.formPersonContract.sumFee = action.payload.sumFee
        updateFeeAfterVoucherTab.form.formData.formPersonContract.sumTax = action.payload.sumTax
        updateFeeAfterVoucherTab.form.formData.formPersonContract.discount = action.payload.discount
        updateFeeAfterVoucherTab.form.formData.formPersonContract._sellingContractPaymentScheduleDtos =
          FormateContractPayment(action.payload._sellingContractPaymentScheduleDtos)
      }
      return updateFeeAfterVoucherState
    case 'UPDATEBUSSINESS':
      const updateBussinessState = JSON.parse(JSON.stringify(state))
      let updateBussinessTab = updateBussinessState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (updateBussinessTab) {
        updateBussinessTab.form.formData[action.payload.form].business = action.payload.bussiness
        updateBussinessTab.form.formData[action.payload.form].businessName =
          action.payload.bussinessName
      }
      return updateBussinessState
    case 'UPDATEPACKAGEVIEW':
      const updatePackageViewState = JSON.parse(JSON.stringify(state))
      let updatePackageViewTab = updatePackageViewState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (updatePackageViewTab) {
        updatePackageViewTab.form.packageCodeView = action.payload.data
      }
      return updatePackageViewState
    case 'UPDATECONTRACTCUSTOMER':
      const updateContractCustomerState = JSON.parse(JSON.stringify(state))
      let updateContractCustomerTab = updateContractCustomerState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (updateContractCustomerTab) {
        updateContractCustomerTab.customerCode = action.payload.code
        updateContractCustomerTab.customerVersion = action.payload.id
      }
      return updateContractCustomerState
    case 'UPDATEPACKAGEADDITIONAL':
      const updatePackageAdditionalState = JSON.parse(JSON.stringify(state))
      let updatePackageAdditionalTab = updatePackageAdditionalState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (updatePackageAdditionalTab) {
        updatePackageAdditionalTab.form.packageConditional = action.payload.data
      }
      return updatePackageAdditionalState
    case 'UPDATEOLDOBJECTINSUREDINFO':
      const updateObjectInsuredInfoFromOldState = JSON.parse(JSON.stringify(state))
      let updateObjectInsuredInfoFromOldTab = updateObjectInsuredInfoFromOldState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (updateObjectInsuredInfoFromOldTab) {
        if (action.payload?.startDate)
          updateObjectInsuredInfoFromOldTab.form.formData.formPersonListUser.startDate =
            action.payload.startDate
        if (action.payload?.expireDate)
          updateObjectInsuredInfoFromOldTab.form.formData.formPersonListUser.expireDate =
            action.payload.expireDate
        updateObjectInsuredInfoFromOldTab.form.formData.formPersonListUser.from =
          action.payload.from
        updateObjectInsuredInfoFromOldTab.form.formData.formPersonListUser.to = action.payload.to
        updateObjectInsuredInfoFromOldTab.form.formData.formPersonListUser.toOther =
          action.payload.toOther
        updateObjectInsuredInfoFromOldTab.form.formData.formPersonListUser.packageCode =
          action.payload.packageCode
        updateObjectInsuredInfoFromOldTab.form.formData.formPersonListUser.coverage =
          action.payload.coverage
      }
      return updateObjectInsuredInfoFromOldState
    default:
      return state
  }
}

export function* saga() {
  yield takeLatest('GETDATAFORMOFFERFEEBYCODE', function* getDataOfferFeeByCodeSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step2GetContractPackageByCode, action.payload)
      if (response && !response.isError) {
        yield put(actions.saveDataFormOfferFee(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETUSERSTEP3BYID', function* getUserStep3ByIdSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step3GetObjectInsuredById, action.payload)
      if (response && !response.isError) {
        yield put(actions.saveUserStep3ById(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETUSERSTEP3BYIDENTITY', function* getUserStep3ByIdentitySaga(action: any) {
    //@ts-ignore
    const response: any = yield call(step3GetObjectInsuredByIdentity, action.payload)

    if (response && !response.isError) {
      if (response.data.objectInsuredInfo && response.data.objectInsuredInfo.customerCode) {
        response.data.sellingContractId = action.payload.sellingContractId
        yield put(actions.saveUserStep3ByIdentity(response.data))
      }
    }
  })
  yield takeLatest('GETLISTUSERSTEP3', function* getListUserStep3Saga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step3GetObjectInsuredList, action.payload)
      if (response && !response.isError) {
        let data = {
          sellingContractId: action.payload.sellingContractId,
          data: response.data,
        }
        yield put(actions.saveListUserStep3(data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETCONTRACTSTEP4BYID', function* getContractStep4ByIdSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step4GetContractByID, action.payload)
      if (response && !response.isError) {
        yield put(actions.saveContractStep4ById(response.data))
      }
    } catch (error) {
      return
    }
  })
}
